import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTABlockProps {
  children: React.ReactNode;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
  price?: string;
  originalPrice?: string;
}
export function CTABlock({
  children,
  subtext,
  className = '',
  fullWidth = false,
  scrollTo,
  href,
  price,
  originalPrice
}: CTABlockProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center justify-center ${className}`} data-id="element-36">
      <button onClick={handleClick} className={`
          group relative overflow-hidden rounded-full bg-[#C4704B] px-8 py-4 
          text-lg font-medium text-white shadow-lg transition-all 
          hover:bg-[#A85A38] hover:shadow-xl hover:-translate-y-0.5
          focus:outline-none focus:ring-2 focus:ring-[#C4704B] focus:ring-offset-2 focus:ring-offset-[#FFFBF5]
          ${fullWidth ? 'w-full max-w-md' : ''}
        `} data-id="element-37">
        {price && <span className="mb-1 flex items-center justify-center gap-2 text-sm" data-id="element-38">
            {originalPrice && <span className="text-white/60 line-through" data-id="element-39">
                {originalPrice}
              </span>}
            <span className="font-bold text-white" data-id="element-40">{price}</span>
          </span>}
        <span className="flex items-center justify-center gap-2" data-id="element-41">
          {children}
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-42" />
        </span>
      </button>
      {subtext && <p className="mt-3 text-sm text-[#8B7D75] italic" data-id="element-43">{subtext}</p>}
    </div>;
}